import { $Qll } from "../utils/query-selector";

/**
 * It assigns a class for empty p tag in order to create spaces generated by shopify
 */
export const assignClassToEmptyText = () => {
  const texts = $Qll('.image-text__content p');

  if(!texts) return;

  texts.forEach(text => {
    if(text.innerText.trim() === '') {
      text.classList.add('image-text__space');
    }
  })
}
